(function () {
  var root = document.getElementById("AstCampaign");
  if (!root) return;

  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---- intro curtain: once per session ---- */
  try {
    var intro = document.getElementById("intro");
    if (intro) {
      var introSeen = false;
      try { introSeen = !!sessionStorage.getItem("ast-intro"); } catch (e) {}
      if (reduce || introSeen) {
        intro.remove();
      } else {
        try { sessionStorage.setItem("ast-intro", "1"); } catch (e) {}
        intro.addEventListener("animationend", function (e) {
          if (e.target === intro) intro.remove();
        });
      }
    }
  } catch (e) {}

  /* ---- petals ---- */
  function burst(x, y, count) {
    if (reduce) return;
    var colors = ["#9e2033", "#b4452f", "#b4945a", "#7c1626", "#c9a26a"];
    for (var i = 0; i < count; i++) {
      var p = document.createElement("div");
      p.className = "petal";
      p.style.left = x + "px";
      p.style.top = y + "px";
      p.style.background = colors[i % colors.length];
      document.body.appendChild(p);
      var a = (Math.random() * 2 - 1) * 1.3 - Math.PI / 2;
      var v = 45 + Math.random() * 80;
      var dx = Math.cos(a) * v;
      var dy = Math.sin(a) * v + 70;
      p.animate(
        [
          { transform: "translate(-50%,-50%) rotate(0deg) scale(1)", opacity: 1 },
          { transform: "translate(calc(-50% + " + dx + "px), calc(-50% + " + dy + "px)) rotate(" + ((Math.random() * 2 - 1) * 280) + "deg) scale(0.65)", opacity: 0 }
        ],
        { duration: 750 + Math.random() * 500, easing: "cubic-bezier(0.2, 0.6, 0.3, 1)" }
      ).onfinish = function () { this.effect.target.remove(); };
    }
  }

  /* ---- ballot selection + tally ---- */
  var list = document.getElementById("scents");
  var tally = document.getElementById("tally");
  var tallycount = document.getElementById("tallycount");
  var formerror = document.getElementById("formerror");
  var submitBtn = document.getElementById("SubmitBtn");

  function selected() {
    return Array.prototype.map.call(
      root.querySelectorAll(".scent-input:checked"),
      function (el) { return el.value; }
    );
  }

  function updateSubmitState() {
    var n = selected().length;
    if (submitBtn) submitBtn.disabled = n === 0;
    if (formerror) formerror.classList.toggle("is-visible", n === 0);
  }
  updateSubmitState();

  if (list) {
    list.addEventListener("change", function (e) {
      var n = selected().length;
      if (tally) tally.classList.toggle("is-visible", n > 0);
      updateSubmitState();
      if (tallycount) {
        tallycount.innerHTML = n === 1
          ? "<strong>1</strong> Duft gewählt"
          : "<strong>" + n + "</strong> Düfte gewählt";
        if (!reduce) {
          tallycount.animate(
            [{ transform: "scale(1)" }, { transform: "scale(1.18)" }, { transform: "scale(1)" }],
            { duration: 260, easing: "ease-out" }
          );
        }
      }
      if (e.target.checked) {
        var r = e.target.parentElement.querySelector(".box").getBoundingClientRect();
        burst(r.left + r.width / 2, r.top + r.height / 2, 7);
      }
    });
  }

  /* ---- form: build tags, then real POST to Shopify ---- */
  var form = document.getElementById("AstVoteForm");
  var scentsfield = document.getElementById("scentsfield");
  var wishfield = document.getElementById("WishField");
  if (form && scentsfield) {
    form.addEventListener("submit", function (e) {
      var picks = selected();
      if (picks.length === 0) {
        e.preventDefault();
        if (formerror) formerror.classList.add("is-visible");
        return;
      }
      var tags = ["duftabstimmung"].concat(picks.map(function (p) {
        return "vote:" + p.replace(/,/g, "");
      }));
      if (wishfield && wishfield.value.trim()) {
        tags.push("wunsch:" + wishfield.value.replace(/,/g, " ").replace(/\s+/g, " ").trim().slice(0, 100));
      }
      var nl = document.getElementById("NewsletterOptIn");
      tags.push("newsletter:" + (nl && nl.checked ? "ja" : "nein"));
      scentsfield.value = tags.join(",");
      try { sessionStorage.setItem("ast-picks", JSON.stringify(picks)); } catch (err) {}
    });
  }

  /* ---- success state after Shopify redirect ---- */
  var confirmed = root.querySelector("[data-confirmed]");
  var postedByUrl = /(?:customer_posted=true|voted=1)/.test(location.search);
  if (confirmed && postedByUrl && !confirmed.classList.contains("is-visible")) {
    confirmed.classList.add("is-visible");
    var ff = document.getElementById("FormFields");
    if (ff) ff.style.display = "none";
    if (tally) tally.classList.remove("is-visible");
  }
  if (confirmed && !confirmed.classList.contains("is-visible")) confirmed = null;
  if (confirmed) {
    var recap = document.getElementById("recap");
    try {
      var picks = JSON.parse(sessionStorage.getItem("ast-picks") || "[]");
      sessionStorage.removeItem("ast-picks");
      if (recap && picks.length) {
        recap.innerHTML = picks.map(function (s) {
          return "<li>" + s.replace(/</g, "&lt;") + "</li>";
        }).join("");
      } else if (recap) {
        recap.remove();
        var thanks = confirmed.querySelector("p");
        if (thanks) thanks.textContent = "Danke, deine Stimme zählt.";
      }
    } catch (e) {}
    setTimeout(function () {
      confirmed.scrollIntoView({ block: "center", behavior: reduce ? "auto" : "smooth" });
      var stamp = confirmed.querySelector(".stamp");
      if (stamp) {
        setTimeout(function () {
          var r = stamp.getBoundingClientRect();
          burst(r.left + r.width / 2, r.top + r.height / 2, 14);
        }, 450);
      }
    }, 150);
  }

  /* ---- countdown centerpiece with rolling digits ---- */
  var segs = {
    d: document.getElementById("cd-d"),
    h: document.getElementById("cd-h"),
    m: document.getElementById("cd-m"),
    s: document.getElementById("cd-s")
  };
  var cdwrap = document.getElementById("cdwrap");
  var cdnote = document.getElementById("cdnote");
  var deadline = new Date(root.dataset.deadline || "");

  function renderSeg(el, str) {
    if (reduce || el.children.length !== str.length) {
      el.textContent = "";
      for (var i = 0; i < str.length; i++) {
        var sp = document.createElement("span");
        sp.className = "cdch";
        sp.textContent = str[i];
        el.appendChild(sp);
      }
    } else {
      Array.prototype.forEach.call(el.children, function (sp, i) {
        if (sp.textContent !== str[i]) {
          sp.textContent = str[i];
          sp.animate(
            [{ transform: "translateY(0.4em)", opacity: 0 }, { transform: "translateY(0)", opacity: 1 }],
            { duration: 280, easing: "cubic-bezier(0.2, 0.7, 0.2, 1)" }
          );
        }
      });
    }
  }

  try {
  if (cdwrap && segs.d && !isNaN(deadline.getTime())) {
    var pad = function (n) { return String(n).length < 2 ? "0" + n : String(n); };
    var tick = function () {
      var ms = deadline - Date.now();
      if (ms <= 0) {
        cdwrap.style.display = "none";
        if (cdnote) cdnote.textContent = "Die Teilnahme ist beendet.";
        return;
      }
      renderSeg(segs.d, pad(Math.floor(ms / 864e5)));
      renderSeg(segs.h, pad(Math.floor(ms % 864e5 / 36e5)));
      renderSeg(segs.m, pad(Math.floor(ms % 36e5 / 6e4)));
      renderSeg(segs.s, pad(Math.floor(ms % 6e4 / 1000)));
      setTimeout(tick, 1000);
    };
    tick();
  } else if (cdwrap) {
    cdwrap.style.display = "none";
  }
  } catch (e) {}

  /* ---- T&C dialog ---- */
  try {
  var tnc = document.getElementById("tncdialog");
  if (tnc && typeof tnc.showModal === "function") {
    Array.prototype.forEach.call(document.querySelectorAll("[data-open-tnc]"), function (btn) {
      btn.addEventListener("click", function () { tnc.showModal(); });
    });
    Array.prototype.forEach.call(tnc.querySelectorAll("[data-close-tnc]"), function (btn) {
      btn.addEventListener("click", function () { tnc.close(); });
    });
    tnc.addEventListener("click", function (e) {
      if (e.target === tnc) tnc.close();
    });
  }
  } catch (e) {}

  /* ---- scroll reveals ---- */
  try {
  var revealables = Array.prototype.slice.call(
    root.querySelectorAll(
      ".infoband-body, .ballot-head, .stimmabgabe-intro, .stimmabgabe-form, #scents > li"
    )
  );
  if (reduce || !("IntersectionObserver" in window)) {
    revealables.forEach(function (el) { el.classList.add("in"); });
  } else {
    Array.prototype.forEach.call(root.querySelectorAll("#scents > li"), function (li, i) {
      li.style.transitionDelay = (i % 6) * 45 + "ms";
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add("in");
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -4%" });
    revealables.forEach(function (el) {
      el.classList.add("rv");
      io.observe(el);
    });
  }
  } catch (e) {}
})();
